import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=5528738f&"
import script from "./privacy.vue?vue&type=script&lang=tsx&"
export * from "./privacy.vue?vue&type=script&lang=tsx&"
import style0 from "./privacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports